import { template as template_fd9b2463e5f141cfb5666b64daa1f11a } from "@ember/template-compiler";
import { concat } from '@ember/helper';
import classNames from 'volta/helpers/class-names';
import trueStringIfPresent from 'volta/helpers/true-string-if-present';
import optional from '@nullvoxpopuli/ember-composable-helpers/helpers/optional';
import or from 'ember-truth-helpers/helpers/or';
import { LinkTo } from '@ember/routing';
import BvMenuItemContent from 'volta/components/bv-menu/item/content';
import BvUnstyledBtn from 'volta/components/bv-unstyled-btn';
import type { TOC } from '@ember/component/template-only';
import type { IBvMenuItem } from 'volta/components/bv-menu';
export interface BvMenuItemSignature {
    Args: {
        item: IBvMenuItem;
        onClick: (event: Event) => void;
    };
    Blocks: {
        default: [];
    };
    Element: HTMLLIElement;
}
const BvMenuItemComponent: TOC<BvMenuItemSignature> = template_fd9b2463e5f141cfb5666b64daa1f11a(`
  <li
    class={{classNames
      'bv-menu-item'
      (if @item.hasArrow 'bv-menu-item--has-arrow')
      (if @item.color (concat 'bv-menu-item--' @item.color))
      (if @item.selected 'bv-menu-item--selected')
    }}
    role='menuitem'
    disabled={{@item.disabled}}
    ...attributes
  >
    {{#if @item.href}}
      <LinkTo
        @route={{@item.href}}
        @model={{@item.model}}
        class='bv-menu-item__inner'
        disabled={{trueStringIfPresent @item.disabled}}
      >
        <BvMenuItemContent @item={{@item}}>
          {{yield}}
        </BvMenuItemContent>
      </LinkTo>
    {{else}}
      <BvUnstyledBtn
        class='bv-menu-item__inner'
        disabled={{trueStringIfPresent (or @item.disabled @item.isLoading)}}
        @onClick={{optional @onClick}}
      >
        <BvMenuItemContent @item={{@item}}>
          {{yield}}
        </BvMenuItemContent>
      </BvUnstyledBtn>
    {{/if}}
  </li>
`, {
    eval () {
        return eval(arguments[0]);
    }
});
export default BvMenuItemComponent;
declare module '@glint/environment-ember-loose/registry' {
    export default interface Registry {
        'BvMenu::Item': typeof BvMenuItemComponent;
        'bv-menu/item': typeof BvMenuItemComponent;
    }
}
